import { render } from "./TagsModal.vue?vue&type=template&id=7f8967cf&scoped=true"
import script from "./TagsModal.vue?vue&type=script&lang=js"
export * from "./TagsModal.vue?vue&type=script&lang=js"

import "./TagsModal.vue?vue&type=style&index=0&id=7f8967cf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f8967cf"]])

export default __exports__